<template>
  <div>
    <b-field v-if="title">
      <div class="mgl-10px has-text-weight-bold mg-auto">{{ title }} </div>
      <div v-if="!isFromDCF">
        <button class="button is-size-7" @click="clearSelection">
          {{ $t('general.panier.clearSelection') }}
        </button>
      </div>
    </b-field>
    <div v-if="info" class="has-text-centered has-text-icon-more mgt-20px">{{ info }} </div>
    <div v-for="(produit, index) in panier" :key="index">
      <div class="mgt-10px has-background-background">
        <div class="columns is-vcentered shadow is-marginless">
          <div class="panier-imgProduit column is-narrow is-paddingless is-flex">
            <img :src="produit.logo"
                 class="panier-imgProduit-logo" v-if="produit.logo"/>
            <div v-else>
              <div class="panier-imgProduit-sponsoring">
              </div>
            </div>
          </div>
          <div class="column mgl-10px is-paddingless">
            <b-field class="mgb-0">
              <div>
                <p class="has-text-link is-size-6 ellipsis has-text-weight-bold textPanier">
                  {{ produit.libelle }}
                </p>
                <p class="has-text-default is-size-7 ellipsis textPanier"
                    v-if="produit.lignesCommande && produit.lignesCommande.length > 0">
                  {{ produit.lignesCommande[0].libelle }}
                </p>
              </div>
              <b-icon v-if="isFromDCF"
                      icon="bookmark-check"
                      type="is-link" size="is-small" class="mgv-auto">
              </b-icon>
            </b-field>
          </div>
          <div class="column is-narrow">
            <a @click="makeDelete(index)" :class="{ 'pointer-events-none' : !canDelete(produit) }">
              <b-icon
                icon="delete-forever"
                :class="{ 'text-access-no-permission': !canDelete(produit) }"
                :type="{ 'is-danger' : canDelete(produit) }">
              </b-icon>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import { DELETE_LIGNE_IN_PANIER, SET_PANIER } from '@/store/modules/bodac/catalogue/produitSponsoring-mutation-type';

const ProduitSponsoring = createNamespacedHelpers('produitSponsoring');

export default {
  props: {
    panier: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      required: false,
    },
    info: {
      type: String,
      required: false,
    },
    isFromDCF: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    ...ProduitSponsoring.mapGetters({
      panierGetter: 'panier',
    }),
  },
  methods: {
    ...ProduitSponsoring.mapMutations({
      deleteProduit: DELETE_LIGNE_IN_PANIER,
      setPanier: SET_PANIER,
    }),
    canDelete(ligne) {
      return (!ligne.commandeId);
    },
    makeDelete(index) {
      this.deleteProduit({ index: index, isFromDCF: this.isFromDCF });
    },
    clearSelection() {
      this.setPanier(this.panierGetter.filter((ligne) => { return ligne.isFromDCF; }));
    },
  },
};
</script>
